import $ from 'jquery';

// ── Hilfsfunktionen: Cookie lesen / schreiben ─────────────────────────────
function holzpreis_getCookie(name) {
    const match = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
    return match ? match[2] : null;
}

function holzpreis_setCookie(name, value, days) {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = name + '=' + value + '; expires=' + expires + '; path=/';
}

// ── Magnific Popup initialisieren ─────────────────────────────────────────
$('.popup_info_cookie').magnificPopup({
    type: 'inline',
    closeOnContentClick: false,
    closeOnBgClick: false,
    closeBtnInside: false,
    showCloseBtn: false,
    autoFocusLast: false,
    callbacks: {
        close: function () {
            if ($('#showagain').is(':checked')) {
                holzpreis_setCookie('holzpreis_info_modal_seen', '1', 30);
            }
        }
    }
});

// ── Custom Close-Button (mfp-close_3n) ───────────────────────────────────
$(document).on('click', '.mfp-close_3n', function () {
    $.magnificPopup.close();
});

// ── Hilfsfunktion: Hat die URL Query-Parameter? ───────────────────────────
function holzpreis_hasUrlParams() {
    return window.location.search.length > 0;
}

// ── Auto-Open beim Seitenaufruf ───────────────────────────────────────────
if (
    $('#holzpreis_popup_info').length &&
    !holzpreis_getCookie('holzpreis_info_modal_seen') &&
    !holzpreis_hasUrlParams()
) {
    $.magnificPopup.open({
        items: {
            src: '#holzpreis_popup_info',
            type: 'inline'
        },
        closeOnContentClick: false,
        closeOnBgClick: false,
        closeBtnInside: false,
        showCloseBtn: false,
        autoFocusLast: false,
        callbacks: {
            close: function () {
                if ($('#showagain').is(':checked')) {
                    holzpreis_setCookie('holzpreis_info_modal_seen', '1', 30);
                }
            }
        }
    });
}

// ── Checkbox vorausfüllen wenn Cookie vorhanden ───────────────────────────
if (holzpreis_getCookie('holzpreis_info_modal_seen')) {
    $('#showagain').prop('checked', true);
}

// ── Checkbox: Cookie löschen wenn abgehakt wird ───────────────────────────
$(document).on('change', '#showagain', function () {
    if (!$(this).is(':checked')) {
        holzpreis_setCookie('holzpreis_info_modal_seen', '', -1);
    }
});
